import { PlatformPromos, UserTag } from '../../../../hooks/useFetchPlatformPromos/types';
import { UserProfileBonusStatus } from '../../../../types.__generated__';
import { ParsedPromo, PromoTypes } from '../../../Layout/Promotions/types';
import { checkIsPromoAllowed, compareWithPromoType } from '../../../Layout/Promotions/utils';

const searchPrizeByTag = (magicXPromo: ParsedPromo, userTag: UserTag): boolean => {
  const isPromoAvailable = magicXPromo.magicXAvailabilityTagName === userTag.tagName;
  const isPromoActive = magicXPromo.magicXActivityTagName === userTag.tagName;

  if (isPromoActive) {
    magicXPromo.status = UserProfileBonusStatus.Claimed;
  } else if (isPromoAvailable && magicXPromo.status !== UserProfileBonusStatus.Claimed) {
    magicXPromo.status = UserProfileBonusStatus.Available;
  }

  return isPromoAvailable || isPromoActive;
};

export const evaluatePromosWithPlatform = (
  promo: ParsedPromo,
  platformPromosObj: PlatformPromos
): ParsedPromo | undefined => {
  const promoType = promo.promoType;
  const platformPromos = platformPromosObj?.platformPromos;
  const { plPromos, rewardsPromos, userTags } = platformPromos;

  const isRegular = compareWithPromoType(promoType, PromoTypes.WAGER_AND_GET);
  const isRewards =
    compareWithPromoType(promoType, PromoTypes.FREE_TICKET) || compareWithPromoType(promoType, PromoTypes.FREE_SPINS);
  const isNetwork = compareWithPromoType(promoType, PromoTypes.NETWORK);
  const isPrize = compareWithPromoType(promoType, PromoTypes.PRIZE);

  const unifiedPromo = isNetwork || isPrize;

  // Magic X promotions and Rewards
  const XPPromo =
    (isRegular || unifiedPromo) && plPromos.find((plPromo) => promo.platformId === String(plPromo.platformId));
  const rewardsPromo =
    isRewards &&
    rewardsPromos.find(
      (rewardsPromo) => promo.platformId === rewardsPromo.platformId && checkIsPromoAllowed(rewardsPromo)
    );
  const prizePromo =
    isPrize && XPPromo && userTags?.filter((userTag) => searchPrizeByTag(XPPromo, userTag)).length && XPPromo;

  // Network promotions
  const contentPromo = unifiedPromo && !promo.tagId && !promo.platformId && promo;
  const availableTagsPromo =
    unifiedPromo && !XPPromo && userTags?.find((userTag) => promo.tagId === userTag.tagId) && promo;

  if (availableTagsPromo) availableTagsPromo.status = UserProfileBonusStatus.Available;

  const platformPromo = prizePromo || XPPromo || rewardsPromo || availableTagsPromo || contentPromo;

  if (platformPromo)
    return {
      ...promo,
      ...platformPromo,
    };
};

export const isAnyPlatformPromoReceived = (platformPromos?: PlatformPromos): boolean | undefined => {
  const receivedPlatfromPromos = platformPromos?.platformPromos;

  return receivedPlatfromPromos && Object.values(receivedPlatfromPromos).some((promo) => promo?.length);
};
